import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { money } from "@/utils/numeral/money";
import { TrendChip } from "@/components/common/chips/TrendChip";

interface NormalizedCostWidgetTableCostCellProps {
  cost: number;
  trend?: number;
}

export const NormalizedCostWidgetTableCostCell: FC<
  NormalizedCostWidgetTableCostCellProps
> = ({ cost, trend }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="caption">{money(cost)}</Typography>
      {trend !== undefined && <TrendChip value={trend} />}
    </Stack>
  );
};
